import { AccessToken } from 'types/dto';

export class TokenExpiredError extends Error {
  /**
   * Class constructor
   *
   * @param {AccessToken} accessToken Expired access token
   * @param {string} refreshToken Refresh token
   */
  public constructor(
    private readonly accessToken: AccessToken,
    private readonly refreshToken: string,
  ) {
    super('Access token has expired');
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }

  /**
   * Get expired access token
   */
  public getAccessToken = () => this.accessToken;

  /**
   * Get refresh token
   */
  public getRefreshToken = () => this.refreshToken;
}
